import React, { useState } from 'react'
import domPurify from 'dompurify'
import { Modal } from '@material-ui/core'
import TextField from '@mui/material/TextField'
import { Button } from '@resiliatech/birdsong'
import { GoalUpdate } from 'Generated/graphql-types'
import {
  Buttons,
  GoalModalContainer,
  Header,
  Inputs,
  SubHeader,
} from './GoalCommentModal.styled'

type GoalCommentModalProps = {
  comment?: GoalUpdate
  isOpen: boolean
  onClose: () => void
  onUpdateGoalComment: (description: string) => void
}

export const GoalCommentModal = ({
  comment,
  isOpen,
  onClose,
  onUpdateGoalComment,
}: GoalCommentModalProps) => {
  const [description, setDescription] = useState(comment?.description || '')

  const handleClose = () => {
    onClose()
  }

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      disableEnforceFocus
    >
      <GoalModalContainer>
        <Header>{comment ? 'Edit' : 'Add'} Comment</Header>
        <SubHeader>
          What’s new with this goal? Write any updates on your progress.
        </SubHeader>
        <Inputs>
          <TextField
            id='goalCommentModalInputName'
            variant='outlined'
            size='small'
            value={domPurify.sanitize(description)}
            onChange={({ target: { value } }) => setDescription(value)}
            required
          />
        </Inputs>
        <Buttons>
          <Button
            label='Cancel'
            onClick={handleClose}
            type='button'
            variant='tertiary'
          />
          <Button
            label={comment ? 'Update' : 'Add'}
            onClick={() => onUpdateGoalComment(description)}
            type='button'
            variant='primary'
            isDisabled={!description}
          />
        </Buttons>
      </GoalModalContainer>
    </Modal>
  )
}
